const REWRITE_CONFIG = {
  'beehiiv-images-production.s3.amazonaws.com': 'media.beehiiv.com',
  'media.beehiiv.net': 'media.beehiiv.com',
  'beehiiv-images-staging.s3.amazonaws.com': 'media.staginghiiv.com',
  'staging-media.beehiiv.net': 'media.staginghiiv.com',
  'community.beehiiv.com': 'community.beehiiv.com',
  'community.staginghiiv.com': 'community.staginghiiv.com',
};

const rewriteSrc = (
  src: string,
  options: { [key: string]: string } = {
    fit: 'scale-down',
    quality: '80',
    format: 'auto',
    onerror: 'redirect',
  },
) => {
  let srcURL = null;

  try {
    srcURL = new URL(src);
  } catch (_e) {
    return src;
  }

  const isRewritable = Object.keys(REWRITE_CONFIG).includes(srcURL.host);

  if (!isRewritable) {
    return src;
  }

  const cdnHost = REWRITE_CONFIG[srcURL?.host as keyof typeof REWRITE_CONFIG] as keyof typeof REWRITE_CONFIG;

  const optionsToString = new URLSearchParams(options).toString().replace(/&/g, ',');

  return `https://${cdnHost}/cdn-cgi/image/${optionsToString}${srcURL?.pathname}${srcURL?.search}`;
};

export default rewriteSrc;
